<template lang="html">
  <div>
    <Header currentMenu="Account" subMenu="Approve Vendors" />
    <div class="dashboard-content-container gap-64">
      <div class="flex-box page-container">
        <Menu currentMenu="Approve Vendors" class="desktop-only" />
        <div class="content">
          <div class="section">
            <h2 class="black bgap-48">Approve Vendors</h2>
            <div v-if="loading">
              <div class="gap-3x" />
              <Spinner />
            </div>
            <div v-if="!loading">
              <div v-for="vendor in vendors" :key="vendor.id">
                <div class="line-break" />
                <div class="gap-3x" />
                <div class="information-container">
                  <div class="information-row">
                    <div class="information-col">Vendor: {{vendor.data.organizationName}}</div>
                    <div class="information-col capitalize">Type: {{vendor.data.type}}</div>
                  </div>
                  <div class="information-row">
                    <div class="information-col">Admin name: {{vendor.organization.admin_name}}</div>
                    <div class="information-col">Admin email: {{vendor.organization.admin_email}}</div>
                  </div>
                  <div class="information-row">
                    <div class="information-col">Status: {{vendor.status}}</div>
                    <div class="information-col">Created at: {{formatDate(vendor.created_at)}}</div>
                  </div>
                  <div class="information-row">
                    Submitted by: {{vendor.user.name}} ({{vendor.user.email}})
                  </div>
                  <div class="link active gap-8" @click="() => openVendorDetail(vendor)">View Detail</div>
                </div>
                <div class="gap-3x" />
              </div>
            </div>
          </div>
          <FooterHelper />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from 'src/components/dashboard/shares/Header.vue'
import Menu from 'src/components/dashboard/shares/Menu.vue'
import FooterHelper from 'src/components/dashboard/shares/FooterHelper.vue'
import EventBus from 'src/components/EventBus.js'
import Spinner from 'src/components/common/Spinner.vue'
import moment from "moment";
// import _ from 'lodash'

export default {
  components: { Header, Menu, FooterHelper, Spinner },
  data() {
    return {
      vendors: [],
      alertMessage: '',
      loading: false,
    }
  },
  methods: {
    assignData(response) {
      this.loading = false
      this.vendors = response.data.vendors
    },
    openVendorDetail(vendor) {
      this.$router.push('/dashboard/vendor_details?id=' + vendor.id)
    },
    formatDate(date) {
      return date ? moment(date).format('LLL') : '';
    }
  },
  computed: {

  },
  created() {
    EventBus.$on('data-submitted-sucessfully', this.afterSubmittedSucessfully)
  },
  beforeDestroy() {
    EventBus.$off('data-submiited-sucessfully', this.afterSubmittedSucessfully)
  },
  mounted() {
    this.loading = true;
    this.$user.fetchMe();
    this.$vendor.fetchVendorRegistrations(this.assignData)
  },
}
</script>

<style lang="scss" scoped>
.information-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  .information-row {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;

    .information-col {
      width: 400px;

      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }

    .capitalize {
      text-transform: capitalize;
    }
  }
}
</style>
